'use strict';

import angular from 'angular';

var trips = function ($q, $http, utils, userModel, Trip) {
  'ngInject';

  var tripConstructorOptions = {
    getUserId: function () {
      return userModel.item.id;
    }
  };

  var collection = Trip.collection.get(null, tripConstructorOptions);

  return {
    collection: collection,
    offer: {},
    accept: {},

    reset() {
      this.collection.reset();
      delete this.lastTripId;
      delete this.hasFailed;
    },

    fetch() {
      var requestOptions = {};
      requestOptions.params = {};
      if (this.lastTripId) {
        requestOptions.params.lastTripId = this.lastTripId;
      }

      this.isFetching = true;

      return new $q((resolve, reject) => {
        $http.get(utils.getApiUrlV2(`trips/${userModel.item.id}`), requestOptions).then((response) => {
          this.lastTripId = response.data.lastTripId;
          this.location = response.data.location;
          this.count = response.data.count;
          this.isFilledSettings = response.data.isFilledSettings;
          collection.add(response.data.trips);
          collection.sort();
          resolve(response.data);
        }).catch((response) => {
          reject(response.data);
          this.hasFailed = true;
        }).finally(() => this.isFetching = false);
      });
    },

    sendOffer() {
      const SEND_OFFER_URL = utils.getApiUrlV2(`bookings/${userModel.item.id}/${this.offer.visitorId}/offer_create`);
      return new $q((resolve, reject) => {
        var postData = {
          tripId: this.offer.tripId,
          message: this.offer.trip.message,
          date: this.offer.trip.date,
          meetingTime: this.offer.trip.meetingTime,
          hours: this.offer.trip.hours,
        };
        $http.post(SEND_OFFER_URL, postData).then((response) => {
          resolve(response.data);
        }).catch((response) => {
          reject(response.data);
        });
      });
    },
  };
};

export default angular
  .module('trips.trips', [])
  .service('trips', trips)
  .name;



// WEBPACK FOOTER //
// ./app/src/components/trips/trips/services/trips.js